import React, { useState, useEffect } from 'react';
import styled from 'styled-components'
import { Asset } from '@archetypes'
import { Panel, GateKeeper, AddressLink } from '@components'
import { ReactComponent as Refresh } from '@assets/Icon_Refresh.svg';
import assetController, { Status } from '@app/App.Controller'

const Placeholder = styled(
	({ className }) => <Panel fadeIn className={className}>
		<Asset.Value />
	</Panel>
)`
	&[data-visible="true"]{
		opacity: 0.4 !important;
	}
	`

const Balance = styled(
	({ className }) => {

		const { wallet, account } = assetController
		const [address, setAddress] = useState()
		const [balances, setBalances] = useState()

		useEffect(() => {
			const sub1 = account.state.subscribe('address', address => setAddress(address), true)
			const sub2 = wallet.state.subscribe('balances', balances => setBalances({ ...balances }), true)
			return () => {
				sub1.unsubscribe()
				sub2.unsubscribe()
			}
		}, []) // eslint-disable-line

		return (
			<GateKeeper
				controllerAssertions={[
					{
						controller: 'account',
						key: 'status',
						assert: val => val === Status.READY,
						onFail: <Panel fadeIn>Connect your wallet to view your balances</Panel>,
					},

				]}
				assertions={[
					{
						assert: () => !!balances,
						onFail: () => <Panel fadeIn><Refresh className='rotate' />Fetching wallet balances</Panel>,
					}
				]}
				dependencies={[Object.keys(balances || {}).length]}
			>
				<div className={className}>
					<div className="-address">
						<AddressLink address={address} start={10} end={6} />
					</div>
					
					<Panel fadeIn>
						<h4>Wallet Balance</h4>
						{balances && Object.keys(balances).length > 2 && Object.keys(balances).map(token =>
							<div className="-balance-item">
								<Asset.Value token={token} {...balances[token]} />
							</div>
						)}
						{balances && Object.keys(balances).length <= 2 && <Placeholder />}
					</Panel>
				</div>
				

			</GateKeeper>
		)
	})`
	padding-left: 10px;
	.-address {
		height: 40px;
	}
	h4 {
		color: var(--color-label, lightblue);
		font-size: 18px;
		margin: 0px;
		margin-bottom: 3rem;
	}
	.-balance-item {
		height: 50px;
		font-size: 14px;
	}

	`

export default Balance